// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3nbTa","inputWrap":"CustomTip_inputWrap__3IIse"};